module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"min":" | {count} min | {count} mins","hr":" | {count} hr | {count} hrs","minute":"min","hour":"hr"},"th":{"min":" | {count} นาที | {count} นาที","hr":" | {count} ชม. | {count} ชม.","minute":"นาที","hour":"ชม."}}')
  delete Component.options._Ctor
}
